import SelectInput from '@/common/components/SelectInput';
import { SubTitle } from '@/common/styles/Mails';
import React from 'react';
import { PROMOTION_CONTACT_FILTERS_OPTIONS } from '../constants/promotionContactFiltersOptions';

const PromotionContactFilters = ({
	setSelectedContactFilter,
	selectedContactFilter,
}) => {
	return (
		<div>
			<SubTitle>Contact:</SubTitle>
			<SelectInput
				showLabel={false}
				selectWidth={440}
				options={PROMOTION_CONTACT_FILTERS_OPTIONS}
				selected={selectedContactFilter}
				setSelected={setSelectedContactFilter}
				multiple={true}
				placeholder={'Select option...'}
			/>
		</div>
	);
};

export default PromotionContactFilters;
